(function ($) {
  $(document).ready(function () {
    jQuery('.home-banner-slider, .did-you-know-slider').slick({
      arrows: true,
      centerPadding: '0px',
      dots: false,
      slidesToShow: 1,
      infinite: false,
    });

    jQuery('.animal-detail-banner-slider').slick({
      arrows: false,
      centerPadding: '0px',
      dots: true,
      slidesToShow: 1,
      infinite: false,
    });

    jQuery('.explore-wild-life-slider').slick({
      arrows: true,
      centerPadding: '250px',
      dots: false,
      slidesToShow: 3,
      centerMode: true,
      responsive: [
        {
          breakpoint: 1500,
          settings: {
            centerPadding: '80px',
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            centerPadding: '120px',
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
            centerPadding: '180px',
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerPadding: '0',
          },
        },
        {
          breakpoint: 250,
          settings: {
            slidesToShow: 1,
            centerPadding: '80px',
          },
        },
      ],
    });

    jQuery('.see-all-picture-item-wrapper').slick({
      arrows: true,
      dots: false,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 400,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 250,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    // jQuery('.home .explore-the-diversity-card-wrapper').slick({
    //   arrows: true,
    //   dots: false,
    //   slidesToShow: 4,
    //   infinite: false,
    //   responsive: [
    //     {
    //       breakpoint: 1500,
    //     },
    //     {
    //       breakpoint: 1200,
    //       settings: {
    //         slidesToShow: 3,
    //       },
    //     },
    //     {
    //       breakpoint: 991,
    //       settings: {
    //         slidesToShow: 2,
    //       },
    //     },
    //     {
    //       breakpoint: 768,
    //       settings: {
    //         slidesToShow: 2,
    //       },
    //     },
    //     {
    //       breakpoint: 650,
    //       settings: {
    //         slidesToShow: 1,
    //       },
    //     },
    //     {
    //       breakpoint: 250,
    //       settings: {
    //         slidesToShow: 1,
    //       },
    //     },
    //   ],
    // });

    jQuery('.explore-the-diversity-card-wrapper').slick({
      arrows: true,
      dots: false,
      slidesToShow: 4,
      infinite: false,
      responsive: [
        {
          breakpoint: 1500,
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 250,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    jQuery('.image-popup-vertical-fit').magnificPopup({
      type: 'image',
      mainClass: 'mfp-with-zoom',
      gallery: {
        enabled: true,
      },

      zoom: {
        enabled: true,

        duration: 300, // duration of the effect, in milliseconds
        easing: 'ease-in-out', // CSS transition easing function

        opener: function (openerElement) {
          return openerElement.is('img')
            ? openerElement
            : openerElement.find('img');
        },
      },
      callbacks: {
        open: function () {
          var self = this;

          // Find and clone the comment icon associated with the current item
          updateCommentIcon(self);
        },
        change: function () {
          var self = this;

          // Update the comment icon when navigating to a new item
          updateCommentIcon(self);
        },
        close: function () {
          // Clean up when the popup closes
          this.wrap.removeClass('mfp-with-comment');
          this.contentContainer.find('.gallery-photo-comment').remove();

          // Remove event delegation if needed
          // $(document).off("click", ".gallery-photo-comment");
        },
      },
    });

    jQuery('.see-all-picture-wrapper .image-popup-vertical-fit').magnificPopup({
      type: 'image',
      mainClass: 'mfp-with-zoom',
      gallery: {
        enabled: true,
      },
      zoom: {
        enabled: true,
        duration: 300,
        easing: 'ease-in-out',
        opener: function (openerElement) {
          // Update this part to target the div with background image
          return openerElement.is('div')
            ? openerElement
            : openerElement.find('div');
        },
      },

      callbacks: {
        open: function () {
          var self = this;

          // Find and clone the comment icon associated with the current item
          updateCommentIcon(self);
        },
        change: function () {
          var self = this;

          // Update the comment icon when navigating to a new item
          updateCommentIcon(self);
        },
        close: function () {
          // Clean up when the popup closes
          this.wrap.removeClass('mfp-with-comment');
          this.contentContainer.find('.gallery-photo-comment').remove();

          // Remove event delegation if needed
          // $(document).off("click", ".gallery-photo-comment");
        },
      },
    });

    function updateCommentIcon(popupInstance) {
      // Remove previous comment icon
      // popupInstance.contentContainer.find('.gallery-photo-comment').remove();
      popupInstance.contentContainer
        .find('.gallery-photo-comment, .contributor-name')
        .remove();
      // Find and clone the comment icon associated with the current item
      var commentIcon = popupInstance.currItem.el.siblings('.overlay')
        .find('.icon')
        .find('.gallery-photo-comment')
        .clone();
        // console.log(commentIcon);
      // Retrieve contributor's name from the hidden span
      var contributorName = popupInstance.currItem.el.siblings('.overlay')
        .find('.icon')
        .find('.contributor-name')
        .text();
      // Create a new element for the contributor's name
      var contributorElement = $('<div>')
        .addClass('contributor-name')
        .text(contributorName);

      // Append the comment icon to the popup
      popupInstance.wrap.addClass('mfp-with-comment');
      popupInstance.contentContainer
        .append(commentIcon)
        .append(contributorElement);

      // Adjust position and ensure it's clickable
      commentIcon.css({
        position: 'absolute',
        bottom: '50px',
        cursor: 'pointer',
        left: '30px ',
        width: '30px',
        height: '30px',
        'object-fit': 'contain',
      });

      // Style the contributor name (adjust as needed)
      contributorElement.css({
        position: 'absolute',
        padding: '10px 20px',
        color: '#fff',
        'font-weight': '600',
        'background-color': 'rgba(0,0,0,.5)',
        bottom: '50px',
        right: '30px',
        'object-fit': 'contain',
      });
    }

    jQuery('.modal-popup').each(function () {
      jQuery(this).on('click', function () {
        jQuery('.modal').show();
        jQuery('body').css('overflow', 'hidden');
        if (jQuery(this).is('img')) {
          const imgSrc = jQuery(this).attr('src');
          jQuery('.modal .modal-content').attr('src', imgSrc);
        } else if (jQuery(this).is('div')) {
          var bg_img = jQuery(this)
            .css('background-image')
            .replace(/^url\(['"](.+)['"]\)/, '$1');
          jQuery('.modal .modal-content').attr('src', bg_img);
        }
      });
    });

    jQuery('.modal-popup').each(function () {
      jQuery(this).on('click', function () {
        jQuery('.modal').show();
        jQuery('body').css('overflow', 'hidden');
        var imgSrc;
        if (jQuery(this).find('img').length > 0) {
          imgSrc = jQuery(this).find('img').attr('src');
        } else if (jQuery(this).is('div')) {
          var bg_img = jQuery(this)
            .css('background-image')
            .replace(/^url\(['"](.+)['"]\)/, '$1');
          imgSrc = bg_img;
        }
        jQuery('.modal .modal-content').attr('src', imgSrc);
      });
    });

    jQuery('.modal .close').on('click', function () {
      jQuery('.modal').hide();
      jQuery('body').css('overflow', 'auto');
    });

    jQuery(
      '.animal-detail-banner-slider-wrapper .image-popup-vertical-fit'
    ).magnificPopup({
      type: 'image',
      mainClass: 'mfp-with-zoom',
      gallery: {
        enabled: true,
      },

      zoom: {
        enabled: true,
        duration: 300, // duration of the effect, in milliseconds
        easing: 'ease-in-out', // CSS transition easing function
        opener: function (openerElement) {
          return openerElement.is('img')
            ? openerElement
            : openerElement.find('img');
        },
      },
    });

    // select
    var itemValue;

    const selectValue = document.querySelectorAll('#reason option');

    $('.select-dropdown__button').on('click', function () {
      $(this).toggleClass('active');
      $(this).next().toggleClass('active');
    });

    $('.mobile-hamburger-menu .menu-icon').on('click', function () {
      $('.menu-icon').toggleClass('open');
      $('.mobile-menu').toggleClass('open');
      $('body').toggleClass('fixed');
    });

    $('.mobile-menu ul li').on('click', function () {
      $(this).addClass('active').siblings().removeClass('active');

      $('.mobile-menu ul li').not(this).removeClass('active');
      $('.mobile-menu ul li ul').slideUp();
      $(this).find('ul').slideToggle();
    });

    $('.mobile-menu ul li').each(function (i, elem) {
      if ($(this).find('ul').length > 0) {
        $(this).children('label').append('<i></i>');
      } else {
        $(this).addClass('no-ul');
      }
    });

    $('.select-dropdown__list .select-dropdown__list-item').on(
      'click',
      function () {
        itemValue = $(this).data('value');
        $(this)
          .parent('.select-dropdown__list')
          .prev()
          .children('span')
          .text($(this).text())
          .parent()
          .attr('data-value', itemValue);
        // $(".select-dropdown__button span")
        //   .text($(this).text())
        //   .parent()
        //   .attr("data-value", itemValue);
        $(this).parent('.select-dropdown__list').prev().toggleClass('active');
        $(this).parent('.select-dropdown__list').toggleClass('active');

        selectValue.forEach((ele) => {
          // console.log("itemValue", ele, itemValue, ele.attributes.value.value);
          if (itemValue === ele.attributes.value.value) {
            ele.setAttribute('selected', 'selected');
          }
        });
      }
    );

    // var tab_name;
    // var tab_content_attr;

    // let tab_ele = document.querySelectorAll('.tab-contents .tab-content')

    // $('.tab-list li').on('click', function(){
    //   $(this).addClass('active').siblings().removeClass('active');
    //   console.log("value", $(this).children('label').attr('data-value'));
    //   tab_name = $(this).children('label').attr('data-value');
    // })

    // console.log("tab_ele", tab_ele);

    // tab_ele.forEach(ele => {
    //   tab_content_attr = $(ele).attr('data-value')
    //   console.log("ele", tab_content_attr);
    //   tab_name === tab_content_attr ? $(ele).addClass('active') : $(ele).removeClass('active');
    // })

    // for faqs
    $('.faqs .faq').on('click', function () {
      $(this).toggleClass('active').siblings().removeClass('active');
    });

    var windowWidth = window.innerWidth;

    if (windowWidth < 992) {
      $('.policy-inner .add-banner').insertAfter($('.banner-inner-page'));
    }

    if (windowWidth < 1200) {
      $('.see-all-picture-wrapper').removeClass('picture-gallery');
    }

    jQuery('.review-listing').slick({
      arrows: true,
      dots: false,
      slidesToShow: 3,
      infinite: false,
    });
  });

  $(document).on('click', '.npx-popup-wrapper', function (e) {
    if ($(e.target).is('.npx-popup-wrapper')) {
      $(this).hide();
    }
    if (!$(e.target).is('.edit-icon-list')) {
      $('.edit-icon-list').hide();
    }
    if (!$(e.target).is('.comment-edit-icon')) {
      $('.comment-edit-icon').hide();
    }
  });
})(jQuery);

(function () {
  // document.addEventListener('DOMContentLoaded', function () {
  //   var label = document.querySelector('label[for="tab2"]');
  //   label.addEventListener('click', function () {
  //     window.scrollTo({ top: 0, behavior: 'smooth' });
  //   });
  // });

  document.addEventListener('DOMContentLoaded', function () {
    function scrollToLabel(labelId) {
      var label = document.querySelector('label[for="' + labelId + '"]');
      if (label) {
        var labelTop = label.getBoundingClientRect().top + window.scrollY;
        console.log('Scrolling to label', labelId);
        window.scrollTo({ top: labelTop - 70, behavior: 'smooth' });
      }
    }

    document.querySelectorAll('input[name="tabs"]').forEach(function (input) {
      input.addEventListener('click', function () {
        var labelId = this.getAttribute('id');
        scrollToLabel(labelId);
      });
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    var faqs = document.querySelectorAll('.faqs');
    faqs.forEach(function (faqs) {
      faqs.addEventListener('click', function (event) {
        // window.scrollTo({ top: 0, behavior: 'smooth' });
        var faqPlace = faqs.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: faqPlace - 40, behavior: 'smooth' });
      });
    });
  });
})();
